import { Benchmark } from "@goodfill/domain-properties";
import { z } from "zod";

export const zBondsBenchmark = z.union([
  z.literal("B_1M"),
  z.literal("B_1Y"),
  z.literal("B_2Y"),
  z.literal("B_3Y"),
  z.literal("B_5Y"),
  z.literal("B_7Y"),
  z.literal("B_10Y"),
  z.literal("B_30Y"),
  z.literal("CB3"),
  z.literal("CB6"),
  z.literal("CB9"),
  z.literal("CB12"),
  z.literal("CT2"),
  z.literal("CT3"),
  z.literal("CT5"),
  z.literal("CT7"),
  z.literal("CT10"),
  z.literal("CT20"),
  z.literal("CT30"),
  z.literal("OB3"),
  z.literal("OB6"),
  z.literal("OB9"),
  z.literal("OB12"),
  z.literal("OT2"),
  z.literal("OT3"),
  z.literal("OT5"),
  z.literal("OT7"),
  z.literal("OT10"),
  z.literal("OT20"),
  z.literal("OT30"),
]);

// This is only type-check code to ensure that `zBondsBenchmark` is same as `Benchmark`
const _: Benchmark = "B_1M";
type _Inferred = z.infer<typeof zBondsBenchmark>;
type _Reference = Benchmark;

// It this line has Type-Error it means that the `zBondsBenchmark` is inconsistent with `Benchmark`
((i: _Inferred, r: _Reference) => {})(_ as _Reference, _ as _Inferred);
